/**
 * 页面文案词典 —— English
 * 第三批：控制台首屏 + 充值管理（资金页）
 */
export default {
  // ---- Dashboard ----
  '当前在线': 'Online Now',
  '今日活跃': 'Active Today',
  '近 7 天活跃': 'Active in Last 7 Days',
  '今日短信请求': 'SMS Requests Today',
  '总用户数': 'Total Users',
  '文章总数': 'Total Articles',
  '总浏览量': 'Total Views',
  '企业数': 'Companies',
  '分类数': 'Categories',
  '敏感词': 'Banned Words',
  '最近活动': 'Recent Activity',
  '暂无活动': 'No activity yet',
  '热门文章': 'Popular Articles',
  '最近交易记录': 'Recent Transactions',
  '付款企业': 'Payer',
  '收款企业': 'Payee',
  '暂无交易记录': 'No transactions yet',
  '次浏览': 'views',

  // ---- Recharge ----
  '待支付': 'Pending Payment',
  '已到账': 'Received',
  '支付失败': 'Payment Failed',
  '已关闭': 'Closed',
  '已退款': 'Refunded',
  '请选择企业': 'Please select a company',
  '请输入正确的金额': 'Please enter a valid amount',
  '授信': 'Credit',
  '充值': 'Recharge',
  '关闭充值单': 'Close Recharge Order',
  '后台关闭': 'Closed by admin',
  '冲正（退款）': 'Reversal (Refund)',
  '后台冲正': 'Reversed by admin',
  '已冲正': 'Reversed',
  '导出成功': 'Export successful',
  '导出失败': 'Export failed',
  '导出CSV': 'Export CSV',
  '订单号': 'Order No.',
  '渠道': 'Channel',
  '性质': 'Type',
  '实收': 'Actual Receipt',
  '用途': 'Purpose',
  '渠道流水号': 'Channel Transaction ID',
  '操作人': 'Operator',
  '到账时间': 'Received At',
  '冲正': 'Reverse',
  '累计充值笔数': 'Total Recharge Orders',
  '累计到账金额': 'Total Received',
  '按渠道': 'By Channel',
  '给企业充值 / 授信': 'Recharge / Grant Credit',
  '给企业钱包充值 / 授信': 'Recharge / Grant Credit to Wallet',
  '确认到账': 'Confirm Receipt',
  '目标企业': 'Target Company',
  '输入企业名称 / 联系人搜索': 'Search by company name / contact',
  '充值性质': 'Recharge Type',
  '充值渠道': 'Payment Channel',
  '平台授信': 'Platform Credit',
  '平台充值': 'Platform Recharge',

  // ---- Transactions ----
  '方向': 'Direction',
  '转入': 'In',
  '转出': 'Out',
  '转账': 'Transfer',
  '交易对手': 'Counterparty',
  '交易时间': 'Transaction Time',
  '交易日期': 'Transaction Date',
  '总交易笔数': 'Total Transactions',
  '总转入金额': 'Total In',
  '总转出金额': 'Total Out',
  '转入笔数': 'In Count',
  '转出笔数': 'Out Count',
  '搜索付款企业或收款企业名称': 'Search payer or payee company name',

  // ---- Withdrawal ----
  '已完成': 'Completed',
  '已通过': 'Approved',
  '请填写驳回原因': 'Please enter a rejection reason',
  '银行户名': 'Bank Account Name',
  '银行账号': 'Bank Account No.',
  '开户行': 'Bank',
  '审核备注': 'Review Note',
  '审核人': 'Reviewed By',
  '处理时间': 'Processed At',
  '申请时间': 'Requested At',
  '总提现': 'Total Withdrawals',
  '通过提现': 'Approve Withdrawal',
  '驳回提现': 'Reject Withdrawal',
  '审核备注（可选）': 'Review note (optional)',
  '请输入驳回原因（必填）': 'Please enter rejection reason (required)',

  // ---- MyWebsite ----
  '抖音': 'Douyin',
  '小红书': 'Xiaohongshu',
  '视频号': 'WeChat Channels',
  '快手': 'Kuaishou',
  '平台': 'Platform',
  '图片已上传': 'Image uploaded',
  '请先绑定抖音': 'Bind Douyin first',
  '已保存，企业官网内容已更新': 'Saved. Your company site has been updated',
  '请先粘贴至少一个链接': 'Paste at least one link first',
  '没有识别到任何链接，请检查粘贴的内容': 'No links detected. Check what you pasted',
  '请至少勾选一项': 'Select at least one item',
  '识别到的名称': 'Detected Name',
  '最终地址': 'Final URL',
  '主页': 'Home',
  '作品': 'Posts',
  '已获取信息': 'Info fetched',
  '仅链接': 'Link only',
  '需上传二维码': 'QR code needed',
  '操作建议': 'Suggested Action',
  '已开通，展示中': 'Enabled and showing',
  '已被管理员暂停展示': 'Paused by admin',
  '尚未开通': 'Not enabled yet',
  '副标题': 'Subtitle',
  '主标题': 'Main Title',
  '编辑官网内容': 'Edit Site Content',
  '当前已被管理员暂停展示': 'Currently paused by admin',
  '抖音用户': 'Douyin User',
  '已过期': 'Expired',
  '已绑定': 'Bound',
  '绑定抖音': 'Bind Douyin',
  '用昵称头像填充抖音格子': 'Fill Douyin tile with nickname & avatar',
  '确定解绑抖音吗？': 'Unbind Douyin?',
  '请联系平台管理员开通': 'Contact the platform admin to enable',
  '上传失败': 'Upload failed',
  '复制失败，请手动选中后复制': 'Copy failed — please select and copy manually',
  '嵌入代码已复制，可直接粘贴到官网': 'Embed code copied — paste it into your site',
};
